import { Component, Inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { fromToolbar, SLIDE_SYNC_TOOLBAR_CONFIG, SlideSyncToolbarConfig, ToolbarActions } from "shared/classroom/toolbar/data-access";
import { ColorOption, StrokeColor } from "shared/classroom/toolbar/core";
import { NgClass, NgStyle, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-color-palette',
    templateUrl: './color-palette.component.html',
    styleUrls: ['./color-palette.component.scss'],
    imports: [NgClass, NgStyle, AsyncPipe]
})
export class ColorPaletteComponent {
    get availableColors(): ColorOption[] { return this.toolbarConfig.colorPalette; }
    readonly activatedColor$ = this.store.select(fromToolbar.selectStrokeColor);

    constructor(
        @Inject(SLIDE_SYNC_TOOLBAR_CONFIG) private readonly toolbarConfig: SlideSyncToolbarConfig,
        private readonly store: Store,
    ) {}

    /** Selects a color in app state by it's name (i.e. key) */
    public selectColor(color: StrokeColor) {
        if (color === undefined) {
            throw new Error(`Invalid color "${color}"`);
        }
        this.store.dispatch(
            ToolbarActions.strokeColorSelected({ strokeColor: color })
        );
    }
}
